import React from 'react';
import { NumberField, SimpleShowLayout } from 'react-admin';
import Heading from 'components/Heading';
import { Typography } from '@mui/material';

export const RateSettingsFields = ({ source, type, taxClassification, activeRate }) => {
  const isBlendedRate = type === 'blended-rate';

  let title = isBlendedRate ? '12hr Rates' : '8hr Rates';

  if (activeRate === 'blended-rate' && isBlendedRate) {
    title += ' (Active)';
  } else if (activeRate === '8-hour-rate' && !isBlendedRate) {
    title += ' (Active)';
  }

  const nestedActiveSettingsObject = isBlendedRate ? 'blended_rates' : 'non_blended_rates';

  return (
    <SimpleShowLayout>
      <Heading>{title}</Heading>
      <SimpleShowLayout sx={{ paddingY: 0, marginBottom: 3 }}>
        <Typography variant="h6" data-testid="heading">
          Charge
        </Typography>
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.charge_overtime_multiplier`}
          label="Charge Overtime Multiplier"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.charge_double_overtime_multiplier`}
          label="Charge Double Overtime Multiplier"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.charge_max_daily_regular_hours`}
          label="Charge Max Daily Regular Hours"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.charge_max_daily_overtime_hours`}
          label="Charge Max Daily Overtime Hours"
        />
      </SimpleShowLayout>

      <SimpleShowLayout sx={{ paddingY: 0, marginBottom: 3 }}>
        <Typography variant="h6" data-testid="heading">
          Pay
        </Typography>
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.payout_overtime_multiplier`}
          label="Payout Overtime Multiplier"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.payout_double_overtime_multiplier`}
          label="Payout Double Overtime Multiplier"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.payout_max_daily_regular_hours`}
          label="Payout Max Daily Regular Hours"
        />
        <NumberField
          source={`${source}.${taxClassification}.${nestedActiveSettingsObject}.payout_max_daily_overtime_hours`}
          label="Payout Max Daily Overtime Hours"
        />
      </SimpleShowLayout>
    </SimpleShowLayout>
  );
};

RateSettingsFields.defaultProps = {
  source: 'ten99',
  type: '8-hour-rate',
  taxClassification: 'ten99',
};
